// extracted by mini-css-extract-plugin
export default {"lockedContainer":"dc_lm","mainFieldset":"dc_ln","rememberMeField":"dc_lp","warningMessage":"dc_lq","warningButtonsContainer":"dc_lr","acceptButton":"dc_ls","declineButton":"dc_lt"};